import useAthlete from 'contexts/AthleteProvider';

import styles from './AboutIndustry.module.scss';

export const AboutIndustry = () => {
  const { athlete } = useAthlete();
  const { defaultSport } = athlete || {};

  const text =
    defaultSport?.name?.toLowerCase() === 'basketball'
      ? `For basketball, The On3 Industry Ranking equally weights the primary recruiting media services. The algorithm is weighted as follows: On3 (25%), 247Sports (25%), Rivals.com (25%), and ESPN (25%).`
      : `The On3 Industry Ranking weights the primary recruiting media services based on past performance data and overall scouting and recruiting coverage investment. The algorithm is weighted as follows: On3 (35%), 247Sports (35%), Rivals.com (20%), and ESPN (10%).`;

  return (
    <div className={styles.block}>
      <h2>Industry Comparison Data</h2>
      <div className={styles.container}>
        <p>
          The On3 Industry Ranking is a proprietary algorithm that compiles
          ratings and rankings from all four primary recruiting media services.
          The On3 Industry Ranking is the industry&apos;s most advanced,
          complete and unbiased rating and ranking measurement.
        </p>
        <p>{text}</p>
      </div>
    </div>
  );
};
